import { Autocomplete, Grid } from "@mui/material";
import StyledTextField from "components/StyledTextField";
import { FC } from "react";
import { useAppSelector } from "store";

export interface OrderLineInfoInputProps {
  info01: string | null;
  setInfo01: (value: string | null) => void;
  info02: string | null;
  setInfo02: (value: string | null) => void;
  info03: string | null;
  setInfo03: (value: string | null) => void;
  info04: string | null;
  setInfo04: (value: string | null) => void;
}

export const OrderLineInfoInput: FC<OrderLineInfoInputProps> = (props) => {
  const { info01, info02, info03, info04, setInfo01, setInfo02, setInfo03, setInfo04 } = props;
  const { orderLineInfo } = useAppSelector((state) => state.cache);

  const info01Dropdown = orderLineInfo.info01?.values || [];
  const info02Dropdown = orderLineInfo.info02?.values || [];
  const info03Dropdown = orderLineInfo.info03?.values || [];
  const info04Dropdown = orderLineInfo.info04?.values || [];

  return (
    <>
      {orderLineInfo.info01?.enabled &&
        (info01Dropdown.length > 0 ? (
          <Grid item container xs={12}>
            <Autocomplete
              freeSolo
              id="info01"
              options={info01Dropdown}
              data-testid="info01"
              renderInput={(params) => (
                <StyledTextField
                  {...params}
                  name="info01"
                  className="info01"
                  label={orderLineInfo.info01?.description}
                />
              )}
              onChange={(_, value: string | null) => {
                setInfo01(value);
              }}
              onInputChange={(_, value: string | null) => {
                setInfo01(value);
              }}
              value={info01}
              fullWidth
              defaultValue={null}
            />
          </Grid>
        ) : (
          <Grid item container xs={12}>
            <StyledTextField
              name="info01"
              className="info01"
              label={orderLineInfo.info01?.description}
              onChange={(event) => setInfo01(event.target.value)}
              fullWidth
            />
          </Grid>
        ))}

      {orderLineInfo.info02?.enabled &&
        (info02Dropdown.length > 0 ? (
          <Grid item container xs={12}>
            <Autocomplete
              freeSolo
              id="info02"
              options={info02Dropdown}
              data-testid="info02"
              renderInput={(params) => (
                <StyledTextField
                  {...params}
                  name="info02"
                  className="info02"
                  label={orderLineInfo.info02?.description}
                />
              )}
              onChange={(_, value: string | null) => {
                setInfo02(value);
              }}
              onInputChange={(_, value: string | null) => {
                setInfo02(value);
              }}
              value={info02}
              fullWidth
            />
          </Grid>
        ) : (
          <Grid item container xs={12}>
            <StyledTextField
              name="info02"
              className="info02"
              label={orderLineInfo.info02?.description}
              onChange={(event) => setInfo02(event.target.value)}
              fullWidth
            />
          </Grid>
        ))}

      {orderLineInfo.info03?.enabled &&
        (info03Dropdown.length > 0 ? (
          <Grid item container xs={12}>
            <Autocomplete
              freeSolo
              id="info03"
              options={info03Dropdown}
              data-testid="info03"
              renderInput={(params) => (
                <StyledTextField
                  {...params}
                  name="info03"
                  className="info03"
                  label={orderLineInfo.info03?.description}
                />
              )}
              onChange={(_, value: string | null) => {
                setInfo03(value);
              }}
              onInputChange={(_, value: string | null) => {
                setInfo03(value);
              }}
              value={info03}
              fullWidth
            />
          </Grid>
        ) : (
          <Grid item container xs={12}>
            <StyledTextField
              name="info03"
              className="info03"
              label={orderLineInfo.info03?.description}
              onChange={(event) => setInfo03(event.target.value)}
              fullWidth
            />
          </Grid>
        ))}

      {orderLineInfo.info04?.enabled &&
        (info04Dropdown.length > 0 ? (
          <Grid item container xs={12}>
            <Autocomplete
              freeSolo
              id="info04"
              options={info04Dropdown}
              data-testid="info04"
              renderInput={(params) => (
                <StyledTextField
                  {...params}
                  name="info04"
                  className="info04"
                  label={orderLineInfo.info04?.description}
                />
              )}
              onChange={(_, value: string | null) => {
                setInfo04(value);
              }}
              onInputChange={(_, value: string | null) => {
                setInfo04(value);
              }}
              value={info04}
              fullWidth
            />
          </Grid>
        ) : (
          <Grid item container xs={12}>
            <StyledTextField
              name="info04"
              className="info04"
              label={orderLineInfo.info04?.description}
              onChange={(event) => setInfo04(event.target.value)}
              fullWidth
            />
          </Grid>
        ))}
    </>
  );
};
